module.exports = __webpack_public_path__ + "mumbai.9332f3fcaedc54287f6be43e4b288179.webp";